
import { Component, Prop, Vue } from "vue-property-decorator";

@Component<any>({})
export default class Canceled extends Vue {}
